import { desktop, mobile, tablet } from "@/utils/responsive";
import styled, { css } from "styled-components";

export const HeaderTemp = styled.div`
  height: 10vh;
  background-color: var(--main);
`;

export const FooterTemp = styled.div`
  height: 5vh;
  background-color: var(--main);
`;

export const Body = styled.div`
  display: grid;
  grid-template-columns: 23% 23% 23% 23%;
  grid-auto-rows: 40%;
  justify-content: center;
  width: 100%;
  height: calc(90vh - 2rem);
  margin: 1rem 0;
  gap: 1rem;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }

  // responsive
  ${mobile(css`
    grid-template-columns: 90%;
  `)}
  ${tablet(css`
    grid-template-columns: 45% 45%;
  `)}
  ${desktop(css`
    grid-template-columns: 22.5% 22.5% 22.5% 22.5%;
  `)}
`;
